import { useUnit } from 'effector-react'
import Link from 'next/link'
import { MenuItem, MenuSection, Separator } from 'react-aria-components'

import { css, cx } from '@portal/styled-system/css'

import { $portalProfile } from '@/entities/profile/portal'
import { getAssetUrl } from '@/shared/lib/cdn'
import { useI18n } from '@/shared/lib/i18n'

import {
    BuildVersionInfo,
    KnowledgeLink,
    LangButton,
    LegalLinks,
    LogoutButton,
    NewsButton,
    SupportContactButton,
} from '../ui'
import { DropdownMenu } from '../ui/dropdown-menu'
import { navbar, navbarMenu } from '../ui/styles/recipe'

export function NavbarAccount() {
    const { i18n, lang } = useI18n()
    const classes = navbar({ isFixed: true })

    return (
        <div className={classes.root}>
            <div className={css({ display: 'flex', alignItems: 'center' })}>
                <Link
                    href={`/${lang}/play/`}
                    className={css({
                        height: '[26px]',
                        display: 'flex',
                        alignItems: 'center',
                        color: 'white',
                        backgroundColor: 'primary',
                        paddingInline: '3',
                        borderRadius: 'sm',
                        fontSize: '[16px]',
                        textTransform: 'uppercase',
                        textDecoration: 'none',
                        _hover: {
                            backgroundColor: 'primary.600',
                        },
                    })}
                >
                    <img
                        src={getAssetUrl('/assets/taongaSwirlWhite.svg')}
                        height="16"
                        width="16"
                        alt=""
                        draggable="false"
                    />
                    <span className={css({ paddingTop: '0.5' })}>&nbsp;{i18n.BUTTON_PLAY}</span>
                </Link>

                <ul className={cx(classes.list, css({ marginLeft: '2' }))}>
                    <NavMenuDropdown />

                    <NewsButton />
                    <SupportContactButton />
                    <KnowledgeLink />
                </ul>
            </div>

            <ul className={cx(classes.list, css({ marginRight: '1' }))}>
                <BuildVersionInfo />
            </ul>
        </div>
    )
}

function NavMenuDropdown() {
    const { i18n, lang } = useI18n()
    const classes = navbarMenu()

    const profile = useUnit($portalProfile)

    return (
        <li>
            <DropdownMenu>
                <MenuItem isDisabled>
                    <div
                        className={css({
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        })}
                    >
                        <div className={css({ padding: '1' })}>
                            <img
                                className={css({ width: '6', height: '6', borderRadius: '[50%]' })}
                                src={profile?.imageURL || getAssetUrl('/assets/avatar/defaultAvatar.png')}
                                alt="avatar"
                            />
                        </div>
                        <div
                            className={css({
                                maxWidth: '[15rem]',
                                padding: '1',
                                textAlign: 'center',
                                lineHeight: 'tight',
                                overflowWrap: 'break-word',
                            })}
                        >
                            {profile?.nick || i18n.PLACEHOLDER_USERNAME}
                        </div>
                    </div>
                </MenuItem>

                <Separator className={classes.separator} />

                <MenuItem className={classes.itemNav} href={`/${lang}/account/`}>
                    <i className={cx('fa-solid fa-user', classes.icon)} />
                    &nbsp;{i18n.PORTAL_PROFILE}
                </MenuItem>

                <LangButton variant="dropdown" />

                <Separator className={classes.separator} />

                {/* Схлопнутая портальная навигация - показывается только на md экранах и меньше */}
                <MenuSection className={css({ width: 'full', display: { lg: 'none' } })}>
                    <NewsButton variant="dropdown" />
                    <SupportContactButton variant="dropdown" />
                    <KnowledgeLink variant="dropdown" />
                    <Separator className={classes.separator} />
                    <LegalLinks />
                    <Separator className={classes.separator} />
                </MenuSection>

                <LogoutButton />
            </DropdownMenu>
        </li>
    )
}
